<template>
	<div>
		<van-nav-bar title="盘库" left-text="返回" left-arrow @click-left="onClickLeft" fixed />
		<div class="psiConfirmCont">
			<div style="display: flex;">
				<van-field v-model="position" center clearable autofocus ref="positionInput" label="货位" placeholder="请输入货位条码">
				</van-field>
			</div>
			<div style="display: flex;">
				<van-field v-model="value" center clearable label="条码" ref="barcodeInput" placeholder="请输入条码">
					<template #button>
						<van-button size="small" type="info" @click="confirm">确定</van-button>
				  	</template>
				</van-field>
			</div>
			<div class="psiDetailCont">
				<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
					<van-list v-model="loading" :finished="finished" @load="onLoad" :finished-text="completeText">
						<div v-for="item in list" class="card" :key="item.uuid" style="width: 100%;">
							<template>
								<table class="layout" style="width: 100%;">
									<tr style="width: 100%;">
										<td style="padding-left: 20px;width: 70%;">{{item.barcode}}</td>
										<td style="text-align: left;width: 30%;"><van-button type="info" size="small" @click="deleteStockDetail(item)">删除</van-button></td>
									</tr>
								</table>
							</template>
						</div>
					</van-list>
				</van-pull-refresh>
			</div>
			<div class="recordBox">
				<van-button type="info" size="large" @click="completeStockTaking()">提交</van-button>
			</div>
			
		</div>
	</div>
</template>

<script>
	import {NavBar, Field, Button, List, PullRefresh,Toast} from 'vant';
    import barcodeService from "../../service/barcodeService";
    import {formatDictionary} from "../../utils/dictionary";
	import userInfo from '../../store/userInfo';
    import moment from "moment";
	export default {
		data() {
			return {
				position: '',
				value: '',
				tempPosition: "",
				tempValue: "",
				positionId: "",
				stockTakingId: '',
                list: [],
                loading: false,
                finished: false,
                pageIndex: 0,
                refreshing: false,
				completeText: "没有更多了"
			};
		},
		mounted: function () {
			this.$refs.positionInput.focus();
			this.stockTakingId = this.$route.query.stockTakingId;
			let that = this;
			document.onkeydown = function(event) {
			    if (event.keyCode == 13) {
					that.tempPosition = that.position;
					that.tempValue = that.value;
					if(that.tempPosition.length > 0){
						if(that.tempPosition.indexOf("HW") < 0 && that.positionId.indexOf("HW") < 0){
							that.value = that.tempPosition;
							this.position = "";
						}
					}
					if(that.tempValue.length > 0){
						if(that.tempValue.indexOf("HW") > -1){
							that.position = that.tempValue;
							that.value = "";
						}
					}
				   if(that.position.length>0 && that.value.length==0){
                       that.$refs.barcodeInput.focus();
				   }else{
                       that.confirm();
				   }
			   }
			}
		},
		components: {
			[NavBar.name]: NavBar,
			[Field.name]: Field,
			[Button.name]: Button,
            [List.name]: List,
            [PullRefresh.name]: PullRefresh
		},
		methods: {
			onClickLeft() {
			    this.$router.go(-1);
			},
			async confirm(){
				let resp = await barcodeService.saveBarcodeStocktakingDetail(this.value, this.position, this.stockTakingId);
	            if (resp.data.Status === "1"){
                	Toast.success('盘点成功');
					this.value = '';
                    this.$refs.barcodeInput.focus();
                    this.stockTakingId = resp.data.Data;
                    this.onRefresh();
	            } else {
					/*top.location.href = "/audio/alert";*/
                	Toast.fail(resp.data.Data);
					this.value = '';
                	if(this.position.length==0){
                        this.$refs.positionInput.focus();
					}else{
                        this.$refs.barcodeInput.focus();
					}
	            }
			},
			async onLoad() {
				this.pageIndex++;
				let resp = await barcodeService.getStockTakingDetailList(this.pageIndex, this.stockTakingId, "detail");
				formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
        		this.loading = false;
        		this.refreshing = false;
				this.list = [...this.list, ...resp.data.Data.data];
				this.finished = resp.data.Data.total <= this.list.length;
				if(resp.data.Data.total == 0){
					this.completeText = "";
				}else{
					this.completeText = "没有更多了";
				}
			},
			onRefresh() {
				this.finished = false;
				this.loading = true;
				this.pageIndex = 0;
				this.list = [];
				this.onLoad();
			},
			async deleteStockDetail(item){
				let resp = await barcodeService.deleteStockTakingDetail(item.uuid);
				if (resp.data.Status === "1"){
					Toast.success('删除成功！');
					this.onRefresh();
				} else {
					Toast.fail(resp.data.Message);
				}
			},
			async completeStockTaking(){
				Toast.loading({
					duration:0,
					message: '处理中...',
					forbidClick: true,
				});
				let resp = await barcodeService.completeStockTaking(this.stockTakingId);
				if (resp.data.Status === "1"){
					Toast.clear();
					Toast.success('提交成功！');
					this.$router.push({path:"stocktakingResult",query:{stockTakingId:this.stockTakingId, creatorId: userInfo.state.userId}})
				} else {
					Toast.clear();
					Toast.fail(resp.data.Message);
					this.value = '';
					this.position = '';
				}
			}
		},
		watch: {
			async position(){
				let resp = await barcodeService.getPositionById(this.position);
				if (resp.data.Status === "1"){
					this.position = resp.data.Data.name;
					this.positionId = resp.data.Data.uuid;
				}
			}
		}
	}
</script>

<style scoped>
	.psiConfirmCont{
		width:100%;
		margin:0 auto;
		margin-top:120px;
		overflow: hidden;
	
	}
	.btnBox {
		
	}
	.recordBox {
		padding: 0.5rem 0;
		box-sizing: border-box;
		margin-top: 2rem;
		bottom:0;
		position:fixed;
		width: 100%;
	}
	.psiDetailCont{
		width:100%;
		margin:0 auto;
		margin-top:20px;
	}
</style>
